module.exports = __webpack_public_path__ + "img/31.fdeb467d.jpg";